import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { OwnersDisplayGridRowDataFragmentGql } from './OwnersDisplayGridRowFragmentGql';

// Should fetch same nodes as DatabaseDownstreamOwnerIdsFilteredByTableQuery
export const DatabaseDownstreamOwnersFilteredByTableQueryGql: DocumentNode = gql`
query DatabaseDownstreamOwnersFilteredByTableQuery($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  tablesConnection(filter: {id: $tableId}) {
    nodes {
      downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...OwnersDisplayGridRowDataFragment
        }
      }
    }
  }
}
${OwnersDisplayGridRowDataFragmentGql}
`;
